import React, { SelectHTMLAttributes } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
}

const Select: React.FC<SelectProps> = ({ label, style, children, ...props }) => {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '100%' }}>
      {label && <span className="mono-label" style={{ margin: 0 }}>{label}</span>}
      <select
        className="control-field"
        style={{
          ...style,
        }}
        {...props}
      >
        {children}
      </select>
    </label>
  );
};

export default Select;
